import { createAction } from 'redux-actions';

export const NAMES = {
  PLAY: 'CLIENT.VIDEO.PLAYBACK_STATUS.SET_PLAY',
  PAUSE: 'CLIENT.VIDEO.PLAYBACK_STATUS.SET_PAUSE',
  RESET: 'CLIENT.VIDEO.PLAYBACK_STATUS.RESET',
  END: 'CLIENT.VIDEO.PLAYBACK_STATUS.SET_END',
  SET: 'CLIENT.VIDEO.PLAYBACK_STATUS.SET',
};

export const playVideo = createAction(NAMES.PLAY);
export const pauseVideo = createAction(NAMES.PAUSE);
export const resetPlaybackStatus = createAction(NAMES.RESET);
export const endVideo = createAction(NAMES.END);
// Oh boy, don't even try to use it anywhere.
export const setPlaybackStatus = createAction(NAMES.SET);



// WEBPACK FOOTER //
// ./src/widget/redux/client/actions/change-playback-status.js